import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Whole-prompt recording in Uncle Danny's voice → object URL (cached in the caller's map), or null.
export async function fetchFounderClip(promptId, cache) {
  const key = `founder::${promptId}`;
  if (cache?.has(key)) return cache.get(key);
  const r = await fetch(`${BACKEND}/api/prompt-audio/${promptId}`);
  if (!r.ok) return null;
  const url = URL.createObjectURL(await r.blob());
  cache?.set(key, url);
  return url;
}

export function useFounderVoicedPrompts() {
  const [ids, setIds] = useState([]);
  useEffect(() => {
    api.get("/prompt-audio").then((r) => setIds(r.data.prompt_ids || [])).catch(() => {});
  }, []);
  return ids;
}
